import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import config from '../config'
import { SIZES } from '../styles/theme'
import { desktopAssets, fixedAssets } from 'src/containers/PreCache'

const Wrapper = styled.div`
  min-height: 100dvh;
  background-image: url(${desktopAssets.landingBg});
  background-size: cover;
  background-position: center;

  .header-logo {
    max-width: 956px;
    width: 100%;
    height: auto;
  }

  .wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .content-wrapper {
    background: rgba(30, 30, 30, 0.7);
    backdrop-filter: blur(3px);
    color: #fff;
    padding-block: 40px;
  }

  .time-wrapper {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8rem;

    ${SIZES.mobile} {
      margin-right: auto;
    }
    .time-card {
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      p {
        font-weight: 400;
        position: relative;
        color: #fff;
        font-size: 16px;
        margin: 0;
        text-transform: uppercase;
      }

      h2 {
        font-weight: 900;
        font-size: 62px;
        margin: 0;
        position: relative;
      }

      ${SIZES.mobile} {
        margin: 0 10px;
        margin-bottom: 10px;
        min-width: 60px;
        width: 10vw;
        p {
          font-size: 0.75rem;
        }

        h2 {
          font-size: 2rem;
        }
      }
    }
  }
`

export default function CountdownTimer() {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = config.EVENT_START_TIME
    const difference = +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft()
      setTimeLeft(newTimeLeft)

      // Check if countdown has reached zero and refresh page
      if (Object.keys(newTimeLeft).length === 0) {
        window.location.reload()
      }
    }, 1000)

    // Cleanup function to clear the timer
    return () => clearTimeout(timer)
  }, [timeLeft])

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    timerComponents.push(
      <div className="time-card" key={interval}>
        <h2>{timeLeft[interval]}</h2>
        <p>{interval}</p>
      </div>
    )
  })
  // const eventStarted = !timerComponents.length

  // if (eventStarted) {
  //   return <></> //Redirect to landing
  // }

  return (
    <Wrapper>
      <div className="wrap relative">
        <div className="p-4 my-4">
          <img src={desktopAssets.countdownKv} alt="Background" className="header-logo" />
        </div>
      </div>
      <div className="content-wrapper d-flex flex-column justify-content-center align-items-center">
        <div className="countdown-container">
          <h4 className="countdown-title text-center">READY TO GO LIVE IN</h4>
          <div className="time-wrapper">{timerComponents.length && timerComponents}</div>
        </div>
      </div>
    </Wrapper>
  )
}
